/* unplugin-vue-components disabled */import script from "./ImgVerify.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImgVerify.vue?vue&type=script&setup=true&lang=ts"

import "./ImgVerify.vue?vue&type=style&index=0&id=42d87226&lang=css"

const __exports__ = script;

export default __exports__